import prettyBytes from 'pretty-bytes';

export interface IFileUploadItemProps {
    name: string;
    size?: number;
    progress?: number;
    file: File;
    onDelete: (file: File) => void;
}

export default function FileUploadItem(props: IFileUploadItemProps) {
    return (
        <>
            <div className="file-upload-item">
                <div className="flex align-center details">
                    <svg width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.2311 15.7692V12.5385C19.2311 10.2444 17.3713 8.38462 15.0772 8.38462H13.2311C12.4664 8.38462 11.8465 7.7647 11.8465 7V5.15385C11.8465 2.85974 9.98671 1 7.69261 1H5.38492M8.15415 1H2.15415C1.38944 1 0.769531 1.61991 0.769531 2.38461V23.6154C0.769531 24.3801 1.38944 25 2.15415 25H17.8465C18.6112 25 19.2311 24.3801 19.2311 23.6154V12.0769C19.2311 5.95931 14.2718 1 8.15415 1Z" stroke="#939492" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    <div className="filename-and-details">
                        <label htmlFor="">{props.name}</label>
                        {props.size && (<p>{prettyBytes(props.file.size)}</p>)}
                        
                        {/* <p className="error">Upload failed</p> */}
                        {props.progress && (
                            <div className="progress-bar">
                                <div className="progress-line-container">
                                    <div className="progress-line" style={{ width: `${props.progress}%` }}></div>
                                </div>
                                <p>{`${props.progress}% done`}</p>
                            </div>
                        )}
                    </div>
                </div>

                <div className="actions">
                    <button title="delete" onClick={() => props.onDelete(props.file)}>
                        <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.3723 9.30769L13.9463 20.3846M8.0528 20.3846L7.62677 9.30769M19.8951 5.35762C20.316 5.42119 20.7355 5.48919 21.1534 5.56159M19.8951 5.35762L18.5808 22.4432C18.4699 23.8859 17.2668 25 15.8198 25H6.17933C4.7323 25 3.52924 23.8859 3.41825 22.4432L2.10398 5.35762M19.8951 5.35762C18.4841 5.14454 17.0568 4.98136 15.6149 4.86994M0.845703 5.56159C1.26364 5.48919 1.68308 5.42119 2.10398 5.35762M2.10398 5.35762C3.51497 5.14454 4.94231 4.98136 6.38417 4.86994M15.6149 4.86994V3.74238C15.6149 2.29086 14.4941 1.07905 13.0433 1.03264C12.3647 1.01094 11.6834 1 10.9995 1C10.3157 1 9.63435 1.01094 8.95575 1.03264C7.50497 1.07905 6.38417 2.29086 6.38417 3.74238V4.86994M15.6149 4.86994C14.0919 4.75225 12.5527 4.69231 10.9995 4.69231C9.44636 4.69231 7.90717 4.75225 6.38417 4.86994" stroke="#939492" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>
            </div>
        </>
    );
}